<template>
  <floor
    :showEmpty="isEmpty"
    :emptyImage="require('@/assets/images/puhui/sy-w2.png')"
    emptyText="乡味筹备中 ~"
    title="土味乡食"
    sub-title="公益助农 感谢有你"
    sub-title-color="#22ac38"
    @show-more="gotoBsyqMiniProgram('/homepage/publicwelfare')"
  >
    <div class="product-list">
      <div
        class="product-item"
        v-for="item in products"
        :key="item.id"
        @click="
          gotoBsyqMiniProgram(
            `/detailspage/morestore/index?id=${item.id}&storeId=${
              item.salesStoreIds ? item.salesStoreIds.split(',')[0] : ''
            }`
          )
        "
      >
        <van-image lazy-load fit="cover" width="100%" height="29.333vw" :src="item.mainPictureUrl" :alt="item.title" />
        <div class="price-box">
          <span class="price">￥{{ item.minPrice }}</span>
          <span class="discount">
            <span class="discount__label">折扣</span>
            <span class="discount__value">{{ item.discount }}</span>
          </span>
        </div>
      </div>
    </div>
  </floor>
</template>

<script>
import Floor from './components/Floor'
import { productLatest } from '@/api/homephone'
import { BSYQ_FRONTEND_URL } from '@/config/domainnameconstant'

export default {
  name: 'ProductFloor',
  components: {
    Floor
  },
  data() {
    return {
      isEmpty: false,
      products: []
    }
  },
  mounted() {
    this.loadProducts()
  },
  methods: {
    /**
     * 加载工贸产品
     */
    loadProducts() {
      // 目前只加载4个
      productLatest({
        current: 1,
        size: 3,
        platform: 0
      }).then(res => {
        const result = (this.products = res.data.data.records)
        if (result.length === 0) {
          this.isEmpty = true
        }
      })
    },

    /**
     * 跳转到播商友圈小程序
     */
    gotoBsyqMiniProgram(path) {
      const url = `${BSYQ_FRONTEND_URL}${path}`
      const link = `/pages/web?needauth=true&url=${encodeURIComponent(url)}`

      this.$callApp('Android', 'GoWXMiniProgramMethod', link)
      this.$callApp('iOS', 'GoWXMiniProgramMethod', link)
    }
  }
}
</script>

<style lang="less" scoped>
.product {
  &-list {
    display: flex;
    justify-content: space-between;
  }

  &-item {
    width: 110px;
    height: 142px;
    border: 1px solid #e4e5e5;
    border-radius: 2px;
    overflow: hidden;
    background-color: #efefef;

    .price-box {
      height: 32px;
      color: #595757;
      position: relative;

      .price {
        font-size: 14px;
        position: absolute;
        left: 6px;
        bottom: 10px;
        font-weight: 400;
      }

      .discount {
        font-size: 13px;
        border-radius: 2px;
        overflow: hidden;
        position: absolute;
        right: 6px;
        bottom: 10px;

        &__label {
          padding: 2px;
          color: #fff;
          background-color: #c31c1f;
        }

        &__value {
          padding: 2px;
          background-color: #fff;
        }
      }
    }
  }
}
</style>
